import RenderHTML from '../../ui-components/RenderHTML'
import { paymentMethodCheckedIcon, paymentMethodUncheckedIcon } from './icons/paymentMethodIcons'

export type PaymentMethodSelectionRadioProps = {
  isSelected: boolean
}

/** Cross-fading checked/unchecked radio indicator for payment method rows. */
export function PaymentMethodSelectionRadio({ isSelected }: PaymentMethodSelectionRadioProps) {
  return (
    <div className='relative flex-shrink-0 ml-3 w-5 h-5'>
      <div
        className={`absolute inset-0 transition-opacity duration-200 ease-out ${isSelected ? 'opacity-0' : 'opacity-100'}`}
      >
        <RenderHTML innerHTMLText={paymentMethodUncheckedIcon} />
      </div>
      <div
        className={`absolute inset-0 transition-opacity duration-200 ease-out ${isSelected ? 'opacity-100' : 'opacity-0'}`}
      >
        <RenderHTML innerHTMLText={paymentMethodCheckedIcon} />
      </div>
    </div>
  )
}
